import { render } from "./LanguageSwitcher.vue?vue&type=template&id=1aaa1658"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"
script.render = render

export default script